import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 18h-6a3 3 0 0 1 -3 -3v-10l-4 4m8 0l-4 -4","key":"svg-0"}]]

const IconCornerLeftUp = createReactComponent('outline', 'corner-left-up', 'CornerLeftUp', __iconNode);

export default IconCornerLeftUp;